export const onInitService = ({ getConfig, setContext }) => {
  setContext(
    "one.rest.header.accessToken.key",
    getConfig("one.rest.header.accessToken.key", "Authorization")
  );

  setContext(
    "one.rest.header.accessToken.value",
    getConfig("one.rest.header.accessToken.value", "Bearer {TOKEN}")
  );

  setContext(
    "one.rest.header.property.name",
    getConfig("one.rest.header.property.name", "headers")
  );

  setContext(
    "one.rest.url.property.name",
    getConfig("one.rest.url.property.name", "url")
  );

  setContext(
    "one.rest.graphql.baseUrl",
    getConfig("one.rest.graphql.baseUrl", "hasuraApi://v1/graphql")
  );
};
